import { Vector3 } from "three";

import Element from "./element";

export default class Reel extends Element {
	width: number;
	height: number;
	topHeight: number;
	footWidth: number;

	constructor({
		id,
		color,
		width,
		height,
		topHeight,
		footWidth
	}: {
		id: string;
		color: string;
		width: number;
		height: number;
		topHeight: number;
		footWidth: number;
	}) {
		super({ id, color, type: "reel" });
		this.width = width;
		this.height = height;
		this.topHeight = topHeight;
		this.footWidth = footWidth;
	}
	getParts() {
		const res: PartDefinition[] = [];
		// Top of the table:
		res.push({
			position: new Vector3(0, (this.height - this.topHeight) / 2, 0),
			dimensions: [this.width, this.topHeight, this.width]
		});
		// foot (square at the center)
		res.push({
			position: new Vector3(0, -this.topHeight / 2, 0),
			dimensions: [this.footWidth, this.height - this.topHeight, this.footWidth]
		});
		return res;
	}
	getBoundingBox() {
		return [this.width, this.height, this.width] as Vector;
	}
	showInfos() {
		return `${this.type}: (${this.width}, ${this.height}) top=${this.topHeight} body=${this.footWidth}`;
	}
	cloneUpdate(name: string, value: string | number) {
		return new Reel({ ...this, [name]: value });
	}
	cloneWithZoom(zoom: number) {
		return new Reel({
			id: this.id,
			color: this.color,
			width: this.width * zoom,
			height: this.height * zoom,
			topHeight: this.topHeight * zoom,
			footWidth: this.footWidth * zoom
		});
	}
	toJson() {
		const { id, color, type, width, height, topHeight, footWidth } = this;
		return { id, color, type, props: { width, height, topHeight, footWidth } };
	}
}
